import { render } from "./RadioInput.vue?vue&type=template&id=355d4c83"
import script from "./RadioInput.vue?vue&type=script&lang=js"
export * from "./RadioInput.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__